import { createSlice } from '@reduxjs/toolkit';

const initialStateRoles = {
    listLoading: false,
    actionsLoading: false,
    rolesList: undefined,
    success: null,
    error: null,
};
export const callTypes = {
    list: "list",
    action: "action"
};

export const rolesListSlice = createSlice({
    name: "rolesList",
    initialState: initialStateRoles,
    reducers: {
        catchError: (state, action) => {
            state.error = action.payload.error;
            state.success = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            };
        },
        catchSuccess: (state, action) => {
            state.error = null;
            state.success = action.payload.success;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            };
        },
        startCall: (state, action) => {
            state.error = null;
            state.success = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            };
        },
        // get List roles
        rolesListFetched: (state, action) => {
            state.listLoading = false;
            state.rolesList = action.payload.rolesList;
            state.error = null;
        },
        clearAll: (state, action) => {
            state.listLoading = false;
            state.actionsLoading = false;
            state.rolesList = undefined;
            state.error = null;
            state.success = null;
        }
    }
});